export enum AsyncStage {
	NoOp = 'NoOp',
	Busy = 'Busy',
	Success = 'Success',
	Error = 'Error',
}
